import { mockSuccessResponse } from '../resolvers/Mutation/Login'

export const SOCIAL_LOGIN_RESPONSE = {
  token: {
    form: null,
    authenticationResponse: {
      ...mockSuccessResponse,
    },
    socialLoginToken: null,
    socialUserId: null,
    socialIdentity: null,
    optInForm: {
      showForm: false,
      __typename: 'OptinForm',
    },
    extensions: {
      ray: 'clGxXaQbEeqqwaU4CiIGvw',
      flags: [],
      experiments: {},
      weight: {
        weight: 0,
        maxWeight: 1000,
      },
      rateLimitersFiring: [
        {
          captchaBypassAvailable: [
            {
              type: 'V2_VISIBLE',
              siteKey: '6Lct1QYUAAAAAFIB-ZaUrFV1YI5fZs0dOL3FgfaY',
            },
            {
              type: 'V2_INVISIBLE',
              siteKey: '6Lf4fiMUAAAAAGRkNt_wJnf79ra2LSdFBlTL-Wcf',
            },
          ],
          rateLimitingBucket: 'MARKETING_MATERIAL_SIGN_UP',
        },
      ],
    },
    __typename: 'SocialAuthenticationResponse',
  },
  moreInfo: {
    authenticationResponse: null,
    socialLoginToken: '7880313f-a2a5-49eb-8c5e-3e9f73fd3741',
    socialUserId: '9fb8e78c-c576-4440-a37e-1f900f6f63a0',
    socialIdentity: {
      fullName: 'Neil Armstrong',
      email: 'neil.armstrong@nasa.gov',
      __typename: 'SocialIdentity',
    },
    optInForm: {
      showForm: false,
      __typename: 'OptinForm',
    },
    form: {
      identifier: 'SOCIAL_LOGIN_MISSING_INFORMATION',
      fields: [
        {
          name: 'email',
          type: 'EMAIL',
          __typename: 'FormField',
          validators: [
            {
              name: 'MAX_LENGTH',
              argument: '256',
              __typename: 'Validator',
            },
            {
              name: 'REGEX_MATCHES',
              argument:
                '^[a-zA-Z0-9.!#$%&*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$',
              __typename: 'Validator',
            },
          ],
          required: true,
          confirmable: true,
          options: null,
        },
        {
          name: 'marketingConsent',
          type: 'MARKETING_CONSENT',
          __typename: 'FormField',
          validators: [],
          required: true,
          confirmable: false,
          options: [
            'I_CONSENT_TO_RECEIVING_MARKETING_MATERIAL',
            'I_DO_NOT_CONSENT_TO_RECEIVING_MARKETING_MATERIAL',
            'KEEP_EXISTING_MARKETING_PREFERENCES',
          ],
        },
      ],
      __typename: 'Form',
    },
    extensions: {
      ray: 'clGxXaQbEeqqwaU4CiIGvw',
      flags: [],
      experiments: {},
      weight: {
        weight: 0,
        maxWeight: 1000,
      },
      rateLimitersFiring: [
        {
          captchaBypassAvailable: [
            {
              type: 'V2_VISIBLE',
              siteKey: '6Lct1QYUAAAAAFIB-ZaUrFV1YI5fZs0dOL3FgfaY',
            },
            {
              type: 'V2_INVISIBLE',
              siteKey: '6Lf4fiMUAAAAAGRkNt_wJnf79ra2LSdFBlTL-Wcf',
            },
          ],
          rateLimitingBucket: 'MARKETING_MATERIAL_SIGN_UP',
        },
      ],
    },
    __typename: 'SocialAuthenticationResponse',
  },
  marketingOnly: {
    authenticationResponse: {
      ...mockSuccessResponse,
    },
    socialLoginToken: '81be69a1-7bb4-4715-a3eb-34f7a97d2d72',
    socialUserId: 'a81a3dfd-96b8-4102-bfbc-3dba408cb783',
    socialIdentity: {
      fullName: 'Neil Armstrong',
      email: 'neil.armstrong@nasa.gov',
      __typename: 'SocialIdentity',
    },
    optInForm: {
      showForm: true,
      __typename: 'OptinForm',
    },
    form: null,
    extensions: {
      ray: 'clGxXaQbEeqqwaU4CiIGvw',
      flags: [],
      experiments: {},
      weight: {
        weight: 0,
        maxWeight: 1000,
      },
      rateLimitersFiring: [
        {
          captchaBypassAvailable: [
            {
              type: 'V2_VISIBLE',
              siteKey: '6Lct1QYUAAAAAFIB-ZaUrFV1YI5fZs0dOL3FgfaY',
            },
            {
              type: 'V2_INVISIBLE',
              siteKey: '6Lf4fiMUAAAAAGRkNt_wJnf79ra2LSdFBlTL-Wcf',
            },
          ],
          rateLimitingBucket: 'MARKETING_MATERIAL_SIGN_UP',
        },
      ],
    },
    __typename: 'SocialAuthenticationResponse',
  },
  linkPending: {
    form: null,
    authenticationResponse: {
      error: 'SOCIAL_LINK_PENDING',
      fieldErrors: null,
      token: null,
      customer: null,
      newCustomer: false,
      __typename: 'AuthenticationResponse',
    },
    socialLoginToken: '01c22f22-ff20-43ce-a2f2-b17bbbc9f4de',
    socialUserId: '754fec89-5326-4093-b098-fa89df2038e9',
    socialIdentity: {
      fullName: 'Neil Armstrong',
      email: 'neil.armstrong@nasa.gov',
      __typename: 'SocialIdentity',
    },
    optInForm: {
      showForm: false,
      __typename: 'OptinForm',
    },
    extensions: {
      ray: 'clGxXaQbEeqqwaU4CiIGvw',
      flags: [],
      experiments: {},
      weight: {
        weight: 0,
        maxWeight: 1000,
      },
      rateLimitersFiring: [
        {
          captchaBypassAvailable: [
            {
              type: 'V2_VISIBLE',
              siteKey: '6Lct1QYUAAAAAFIB-ZaUrFV1YI5fZs0dOL3FgfaY',
            },
            {
              type: 'V2_INVISIBLE',
              siteKey: '6Lf4fiMUAAAAAGRkNt_wJnf79ra2LSdFBlTL-Wcf',
            },
          ],
          rateLimitingBucket: 'MARKETING_MATERIAL_SIGN_UP',
        },
      ],
    },
    __typename: 'SocialAuthenticationResponse',
  },
  invalidToken: {
    form: null,
    authenticationResponse: {
      error: 'INVALID_SOCIAL_AUTHENTICATION_TOKEN',
      fieldErrors: null,
      token: null,
      customer: null,
      newCustomer: false,
      __typename: 'AuthenticationResponse',
    },
    socialLoginToken: '01c22f22-ff20-43ce-a2f2-b17bbbc9f4de',
    socialUserId: '754fec89-5326-4093-b098-fa89df2038e9',
    socialIdentity: {
      fullName: 'Neil Armstrong',
      email: 'neil.armstrong@nasa.gov',
      __typename: 'SocialIdentity',
    },
    optInForm: {
      showForm: false,
      __typename: 'OptinForm',
    },
    extensions: {
      ray: 'clGxXaQbEeqqwaU4CiIGvw',
      flags: [],
      experiments: {},
      weight: {
        weight: 0,
        maxWeight: 1000,
      },
      rateLimitersFiring: [
        {
          captchaBypassAvailable: [
            {
              type: 'V2_VISIBLE',
              siteKey: '6Lct1QYUAAAAAFIB-ZaUrFV1YI5fZs0dOL3FgfaY',
            },
            {
              type: 'V2_INVISIBLE',
              siteKey: '6Lf4fiMUAAAAAGRkNt_wJnf79ra2LSdFBlTL-Wcf',
            },
          ],
          rateLimitingBucket: 'MARKETING_MATERIAL_SIGN_UP',
        },
      ],
    },
    __typename: 'SocialAuthenticationResponse',
  },
}
